module.exports = __webpack_public_path__ + "img/public/SiteIcons/streeingFormIcon.svg?73c848c4";